import React from 'react';
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";

function TagStack({tags}) {
    if (tags) {
        return <div>
            <strong>Tags:</strong>
            <Stack direction="row" spacing={1} style={{marginTop: "1%"}} sx={{flexWrap: "wrap"}}>
                {tags.map((tag) => (<Chip label={tag.display_name} variant="outlined" key={`id-tag-${tag.display_name}`}/>))}
            </Stack>
        </div>

    } else {
        return <div><p>No Tags.</p></div>
    }
}

export default TagStack;